import { defineMessages } from 'react-intl';

export default defineMessages({
    watercraftHeader: {
        id: 'wmic-pe-capability-gateway-common-ho-react.WMICHOWatercraftCoverages.Watercraft Header',
        defaultMessage: 'Watercraft #{riskID}: {riskDescription}',
    },
});
